import { connect } from 'react-redux';
import { getVisiblePanel } from '../../redux/selectors';
import { hidePanelPopup } from '../../redux/actions';
const mapStateToProps = (state, { actionBarType })=>{
    return {
        visiblePanel: getVisiblePanel(state, actionBarType)
    };
};
const mapDispatchToProps = {
    onClose: hidePanelPopup
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=PanelPopup.container.js.map